import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import apiRequest from "../../../utils/towerHeadAdmin/apiRequest";
import InputField from "../../ui/form/InputField";
import Button from "../../ui/utils/Button";
import toast from "react-hot-toast";
import CheckboxField from "../../ui/form/CheckboxField";
import SelectField from "../../ui/form/SelectField";
import usePost from "../../../hooks/api/usePost";
import Alert from "../../ui/utils/Alert";
import { formatDateUs } from "../../../utils/helper";

const EditCateteriaInventory = ({ data, closeModal, callback }) => {
  const {
    error,
    isLoading: loading,
    post,
    serverErrors,
  } = usePost(apiRequest.updateVendorCompliance);
  const formik = useFormik({
    initialValues: {
      code: data?.code,
      discountType: data?.discountType,
      discountValue: data?.discountValue,
      usageLimit: data?.usageLimit,
      isActive: data?.isActive,
      validFrom: formatDateUs(data?.validFrom),
      validUntil: formatDateUs(data?.validUntil),
    },
    validationSchema: Yup.object({
      code: Yup.string().required("Coupon code is required"),
      discountType: Yup.string().required("Discount type is required"),
      discountValue: Yup.number()
        .typeError("Must be a number")
        .required("Discount value is required"),
      usageLimit: Yup.number().typeError("Must be a number").nullable(),
      isActive: Yup.boolean().required(),
      validFrom: Yup.date().required("Valid From date is required"),
      validUntil: Yup.date()
        .required("Valid Until date is required")
        .min(Yup.ref("validFrom"), "Valid Until must be after Valid From"),
    }),
    onSubmit: async (values, { resetForm }) => {
      const response = await post({ data: { body: values, id: data?._id } });
      if (response.response) {
        callback?.();
        resetForm();
        closeModal();
      }
    },
  });

  return (
    <div>
      <h2 className="p-4 text-lg font-semibold">Update Coupon</h2>
      <div className="border-b" />
      <form onSubmit={formik.handleSubmit} className="text-sm">
        {error && <Alert message={error} type="error" />}
        <div className="grid grid-cols-1 gap-2 p-4 sm:grid-cols-2">
          <InputField
            name="code"
            label="Coupon Code"
            placeholder="Enter code"
            value={formik.values.code}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            serverError={serverErrors?.code}
            error={formik.touched.code && formik.errors.code}
          />

          <SelectField
            name="discountType"
            label="Discount Type"
            placeholder="Discount Type"
            value={formik.values.discountType}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            serverError={serverErrors?.discountType}
            error={formik.touched.discountType && formik.errors.discountType}
            options={[
              { label: "Percentage", value: "percentage" },
              { label: "Fixed", value: "fixed" },
            ]}
          />
          <InputField
            type="number"
            name="discountValue"
            label="Discount Value"
            placeholder="Enter discount value"
            value={formik.values.discountValue}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            serverError={serverErrors?.discountValue}
            error={formik.touched.discountValue && formik.errors.discountValue}
          />

          <InputField
            type="number"
            name="usageLimit"
            label="Usage Limit (optional)"
            placeholder="e.g. 10"
            value={formik.values.usageLimit}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            serverError={serverErrors?.usageLimit}
            error={formik.touched.usageLimit && formik.errors.usageLimit}
          />
          <InputField
            name="validFrom"
            label="Valid From"
            type="date"
            value={formik.values.validFrom}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            serverError={serverErrors?.validFrom}
            error={formik.touched.validFrom && formik.errors.validFrom}
          />

          <InputField
            name="validUntil"
            label="Valid Until"
            type="date"
            value={formik.values.validUntil}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            serverError={serverErrors?.validUntil}
            error={formik.touched.validUntil && formik.errors.validUntil}
          />
          <CheckboxField
            checked={formik.values.isActive}
            name="isActive"
            label=" Is Active"
            id="isActive"
            value={formik.values.isActive}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            serverError={serverErrors?.isActive}
            error={formik.touched.isActive && formik.errors.isActive}
          />
        </div>

        <div className="border-b" />
        <div className="flex justify-end gap-2 p-4">
          <Button variant="secondary" onClick={closeModal}>
            Cancel
          </Button>
          <Button
            type="submit"
            variant="primary"
            loadingText="Updating..."
            isLoading={loading}
          >
            Update
          </Button>
        </div>
      </form>
    </div>
  );
};

export default EditCateteriaInventory;
